import { Dict } from '@prometheus/types';
import produce from 'immer';
import React, { Reducer, useCallback, useReducer } from 'react';

interface UseStorageStateInterface {
  storage: Dict<any>;
}
interface UseStorageInterface extends UseStorageStateInterface {
  initStorage: (name: string) => {
    get: (attr: string) => any;
    set: (value: any, attr: string, subAttr?: string) => void;
  };
}

export const INITIAL_STATE = {
  storage: {},
};

export const reducer = (state: UseStorageStateInterface, action: any) => {
  return produce(state, (draft: UseStorageStateInterface) => {
    switch (action.type) {
      case 'INIT':
        if (!draft.storage[action.payload]) {
          draft.storage[action.payload] = {};
        }
        break;
      case 'SET_STORAGE':
        if (!draft.storage[action.payload.name]) {
          draft.storage[action.payload.name] = {};
        }

        if (action.payload.attr) {
          draft.storage[action.payload.name][action.payload.attr] =
            action.payload.value;
        } else {
          draft.storage[action.payload.name] = action.payload.value;
        }

        // if (
        //   !draft.storage[action.payload.name][action.payload.attr] &&
        //   action.payload.subAttr
        // ) {
        //   draft.storage[action.payload.name][action.payload.attr] = {};
        //   draft.storage[action.payload.name][action.payload.attr][
        //     action.payload.subAttr
        //   ] = action.payload.value;
        // } else if (
        //   !draft.storage[action.payload.name][action.payload.attr] &&
        //   !action.payload.subAttr
        // ) {
        //   draft.storage[action.payload.name][action.payload.attr] =
        //     action.payload.value;
        // } else {
        //   draft.storage[action.payload.name][action.payload.attr] =
        //     action.payload.value;
        // }
        break;
    }
  });
};

export const useStorage = (): UseStorageInterface => {
  const [state, dispatch] = useReducer<any, any>(reducer, INITIAL_STATE);

  const { storage } = state;

  const initStorage = (name: string) => {
    dispatch({
      type: 'INIT',
      payload: name,
    });
    return {
      get: (attr: string) => {
        return getStorage(name, attr);
      },
      set: (value: any, attr: string, subAttr?: string) => {
        return setStorage(name, value, attr);
      },
    };
  };

  const getStorage = useCallback(
    (name: string, attr: string) => {
      const result = {};

      if (state[name]) {
        return state[name][attr];
      }

      return result;
    },
    [state]
  );

  const setStorage = useCallback(
    (name?: string, value?: any, attr?: string) => {
      dispatch({
        type: 'SET_STORAGE',
        payload: {
          name,
          value,
          attr,
        },
      });
    },
    [state]
  );

  return {
    storage,
    initStorage,
  };
};
